import { ApolloError } from "@apollo/client";

/**
 * NOTE: duplicated from `apps/aphrodite/src/graphql/errors.ts`. Kept local to
 * athena deliberately, to limit this change to one workspace. If a third
 * consumer appears, lift this into `@vericus/cadmus-common` and have both apps
 * re-export it.
 */

/** Standardised error returned for HTTP 401. */
export function isUnauthorizedError(error: ApolloError) {
  if (
    error.networkError &&
    "statusCode" in error.networkError &&
    error.networkError.statusCode === 401
  ) {
    return true;
  }
  // Authorization error returned by the server (old form)
  if (error.graphQLErrors.map((e) => e.message).includes("bad_role")) {
    return true;
  }
  return matchGraphQLErrorCode(error, ["UNAUTHORIZED"]);
}

/**
 * Checks if the given ApolloError contains a GraphQL error with a matching
 * code (new format) or reason (deprecated format).
 *
 * @param error the ApolloError to check
 * @param codes an array of error codes or reasons to match against
 * @returns true if a matching error code or reason is found, false otherwise
 */
export function matchGraphQLErrorCode(error: ApolloError, codes: string[]) {
  if (error.graphQLErrors.length > 0) {
    return error.graphQLErrors.some((gqlErr) => {
      if ("code" in gqlErr && typeof gqlErr.code === "string") {
        return codes.includes(gqlErr.code);
      }
      if ("reason" in gqlErr && typeof gqlErr.reason === "string") {
        return codes.includes(gqlErr.reason);
      }
      return false;
    });
  }
  return false;
}
